module.exports = __webpack_public_path__ + "static/img/差评-默认状态@4x.99bb4414.png";